import React from 'react'

import { MapTeamPositionContext } from '@/components/organisms/Map/Markers/MapTeamPositionProvider.tsx'

import { CarMarker, type CarMarkerProps } from './CarMarker.tsx'

interface TeamMarkerData {
  teamId: string
  carNumber: string
  carType?: 'automatic' | 'manual' | 'electric'
  vip?: boolean
}

export type TeamMarkerProps = TeamMarkerData &
  Omit<CarMarkerProps, 'label' | 'manual' | 'electric' | 'vip' | 'position'> &
  Partial<Pick<CarMarkerProps, 'position'>>

export const TeamMarker: React.FC<TeamMarkerProps> = ({ teamId, position, carNumber, carType, vip, ...props }) => {
  const positions = React.useContext(MapTeamPositionContext)
  const teamPosition = position ?? positions[teamId]
  return (
    teamPosition && (
      <CarMarker
        {...props}
        position={teamPosition}
        label={carNumber}
        manual={carType === 'manual'}
        electric={carType === 'electric'}
        vip={vip}
      />
    )
  )
}
